/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { QuantityUpdater } from './QuantityUpdater'
import { Button } from 'semantic-ui-react'
import React, { useContext } from 'react'
import { AdjustWeight } from '../AdjustWeight'
import { UltyModalWrapperContext } from '../../../../../Shared/UltyModalWrapper/UltyModalWrapperContext'
import { useTranslation } from 'react-i18next'

const AdjustQuantityOrWeight = ({ order, orderItem,fulfillmentReplacement }) => {
    const [t] = useTranslation()
    const {handleUltyModalWrapper} = useContext(UltyModalWrapperContext)

    const showAdjustWeightModal = () => {
        const modalSettings = {
            size: 'tiny',
            component: <AdjustWeight
              orderId={order.id}
              platformModule={order.platform.module}
              orderItem={orderItem}
              pickingMethod='MANUAL'
              onSubmit={() => {
                  handleUltyModalWrapper(false, null)
              }}
            />,
        }

        handleUltyModalWrapper(true, modalSettings)
    }


    return (
      <>
          {!orderItem.item || !orderItem.item.pricedByUnit || orderItem.item.pricedByUnit.type === 'COUNT' ? (
            <QuantityUpdater
              orderId={order.id}
              orderItem={orderItem}
              fulfillmentReplacement={fulfillmentReplacement}
            />
          ) : (
            <Button
              css={css`
                      &.ui.button {
                            margin-right: 0.2rem;
                      }
                  `}
              onClick={showAdjustWeightModal}
            >
                {t('order.pickup.adjust_weight.adjust_weight')}
            </Button>
          )}
      </>
    )
}

export { AdjustQuantityOrWeight }
